// extracted by mini-css-extract-plugin
export default {"faq":"Faq_faq__17rZx","con":"Faq_con__w01u9","faqBody":"Faq_faqBody__svWTu","faq__btn":"Faq_faq__btn__mvPMt"};